// src/custom-product-defaults.ts
var DEFAULT_CUSTOM_PRODUCT_BRAND = {
  suffix: "Custom",
  brandColor: "oklch(0.7 0.0913 159.88)"
};

export {
  DEFAULT_CUSTOM_PRODUCT_BRAND
};
